import WizardController           from '../wizard_controller'
import ScrollToErrorMixin         from '../../support/scroll_to_error_mixin'
import BloodPressureCheckMixin    from '../../support/blood_pressure_check_mixin'
import BmiMixin                   from '../../support/bmi_mixin'
import GlucoseIndicatorMixin      from '../../support/glucose_indicator_mixin'
import Vo2MaxMixin                from '../../support/vo2_max_mixin'
import ThreeMinStepTestMixin      from '../../support/three_min_step_test_mixin'
import mixin                      from '../../support/mixin'

export default class extends mixin(
  WizardController,
  ScrollToErrorMixin,
  BloodPressureCheckMixin,
  BmiMixin,
  GlucoseIndicatorMixin,
  Vo2MaxMixin,
  ThreeMinStepTestMixin
) {
}
